import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center px-4 py-24 md:py-32 overflow-hidden bg-bg-primary" data-id="element-132">
      {/* Subtle radial gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(201,168,76,0.04)_0%,#0A0A0A_100%)] pointer-events-none" data-id="element-133" />

      <div className="relative max-w-4xl mx-auto text-center" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-block bg-bg-card border border-border-subtle rounded-full px-4 py-2 mb-8" data-id="element-135">
          <span className="text-sm font-semibold text-text-secondary" data-id="element-136">
            🔴 LibrofyStore™
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-text-primary font-display text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-137">
          ¿Hasta cuándo vas a ser el que las{' '}
          <span className="text-text-gold" data-id="element-138">persigue</span>?
        </motion.h1>

        <motion.img src="https://cdn.magicpatterns.com/uploads/9qgs7vACJFJr6yMxwHsEad/1.webp" alt="EFECTO IMÁN™ — Sistema completo: 3 módulos, Código Acelerado y bonos" width={665} height={553} loading="eager" fetchPriority="high" decoding="async" sizes="(max-width: 768px) 100vw, 665px" initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.15
      }} style={{
        aspectRatio: '665 / 553'
      }} className="w-full max-w-2xl mx-auto h-auto mb-8" data-id="element-139" />

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-text-primary font-display text-2xl md:text-3xl font-bold mb-8" data-id="element-140">
          <span className="text-text-gold" data-id="element-141">EFECTO IMÁN:</span> El sistema
          psicológico para que ellas den el primer paso.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-text-secondary text-base md:text-lg mb-10 leading-relaxed max-w-[640px] mx-auto" data-id="element-142">
          No es magia, es comportamiento humano. Dejá de{' '}
          <span className="text-red-urgency" data-id="element-143">improvisar</span> y empezá a usar
          un <strong className="text-text-primary" data-id="element-144">sistema</strong> diseñado
          para el hombre que ya tiene su vida armada pero quiere{' '}
          <strong className="text-text-primary" data-id="element-145">resultados</strong> diferentes.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-146">
          {['📱 100% Digital', '⚡ Acceso en 5 min', '🇦🇷 Para hombres ARG 30-45', '🧠 Sistema Psicológico'].map((badge, i) => <div key={i} className="bg-bg-card border border-border-subtle rounded-full px-4 py-2" data-id="element-147">
              <span className="text-[13px] text-text-secondary" data-id="element-148">{badge}</span>
            </div>)}
        </motion.div>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} onClick={() => document.getElementById('elegi-tu-plan')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full md:w-auto bg-gold-primary text-black font-bold text-lg py-4 px-10 rounded-md shadow-gold hover:bg-gold-bright hover:shadow-gold-hover transition-all uppercase mb-6" data-id="element-149">
          🔴 ACTIVAR MI EFECTO IMÁN
        </motion.button>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-wrap justify-center gap-4 text-[13px] text-text-secondary" data-id="element-150">
          <span className="flex items-center gap-2 bg-bg-card border border-border-subtle rounded-full px-3 py-1" data-id="element-151">
            🛡️ Garantía 7 días
          </span>
          <span className="flex items-center gap-2 bg-bg-card border border-border-subtle rounded-full px-3 py-1" data-id="element-152">
            🔒 Pago seguro
          </span>
          <span className="flex items-center gap-2 bg-bg-card border border-border-subtle rounded-full px-3 py-1" data-id="element-153">
            💳 Mercado Pago
          </span>
        </motion.div>
      </div>
    </section>;
}